import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { CONSTANT } from '../../utils/constant';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';

const SBSTISalesForm = ({ values, labels, touched, errors }) => {
  const {
    KEYS: { ROLES }
  } = CONSTANT;

  return (
    <>
      <div className="main-content-form-headers">
        <span className="select-placeholder">{labels.SALES_REP_ID}</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${errors.salesRepId && touched.salesRepId ? 'error' : ''
          }`}
      >
        <Field
          placeholder={labels.SALES_REP_ID}
          className="select-style"
          name="salesRepId"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="registration-error">{errors.salesRepId}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

SBSTISalesForm.propTypes = {
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired
};

export default SBSTISalesForm;
